import { render, staticRenderFns } from "./SkinModal.vue?vue&type=template&id=45f303ac"
import script from "./SkinModal.vue?vue&type=script&lang=ts"
export * from "./SkinModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f303ac')) {
      api.createRecord('45f303ac', component.options)
    } else {
      api.reload('45f303ac', component.options)
    }
    module.hot.accept("./SkinModal.vue?vue&type=template&id=45f303ac", function () {
      api.rerender('45f303ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/skin-status/SkinModal.vue"
export default component.exports